import $ from "jquery";
import debug from 'bows/dist/bows.min.js';

let $carousel = $('[data-slider="social"]');
const log = debug("sliders:social");

function setControls($self, $sn) {
  let currentImageHeight = $self.find('img').height();
  if ( currentImageHeight != 0 ) {
    $sn.css('top', currentImageHeight / 2);
  }
}

function sliderInit() {

  $carousel.each(function () {
    let $this = $(this);
    let role = $this.attr('role');
    let $carousel = $this.closest('.slider-contain');
    let $sn = $carousel.find('.slider-nav');
    let $sb = $carousel.find('.slider-nav__arrows');

    if (role !== 'region') {
      let $slider = $this.slick({
        dots: false,
        mobileFirst: true,
        speed: 500,
        infinite: false,
        variableWidth: false,
        slidesToShow: 1,
        arrows: false,

        slidesToScroll: 1,
        touchThreshold: 20,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: false,
              variableWidth: false,
              arrows: true,
              appendArrows: $sb,
              //appendArrows: appendArrowsTo
            }
          }
        ]
      });

      setTimeout(() => {
        setControls($this.find('.slick-current'), $sn);
      }, 100);

      $slider.on('afterChange', function (event, slick, currentSlide) {
        setControls($this.find(`[data-slick-index="${currentSlide}"]`), $sn);
      });

      $(window).on('resize', function () {
        setTimeout(() => {
          setControls($this.find('.slick-current'), $sn);
        }, 100);
      }).on('load', function () {
        setControls($this.find('.slick-current'), $sn);
      })
    }
  });
}

export function init() {
  if ($carousel.length) {
    sliderInit();
  }
}

export default {
  init
};
